// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "section.theme--dark[data-v-f5c63ca6]{background-color:var(--v-background-dark-base)!important;color:var(--v-text-dark-base)!important}section.theme--light[data-v-f5c63ca6]{background-color:var(--v-background-light-base)!important;color:var(--v-text-light-base)!important}.header[data-v-f5c63ca6]{margin-bottom:20px;font-size:30px!important}.description[data-v-f5c63ca6]{font-size:20px}", ""]);
// Exports
module.exports = exports;
